import type { DeepPartial } from '@luna/utils-ts';

import type { SavingsConfig } from '../../ProductsConfig';

export const termDepositOverviewConfig: DeepPartial<SavingsConfig['overview']['termDeposit']> = {
    showBalance: true,
    showFixedDeposit: true,
    showOpeningDate: true,
    showRollover: true,
    showCapitalization: true,
    showInterestBookingDisposition: true,
    showInterestBookingDispositionType: {
        subaccount: true,
    },
    showCreditInterestRate: true,
    showCreditInterestRateBonus: true,
    showTotalInterestRate: true,
};
